const createTextContainer = ({
  text,
  containerTag = "div",
  textTag = "p",
  allowHTML = false
}) => {
  if (!text) {
    return null;
  }
  const container = document.createElement(containerTag);
  if (textTag === null) {
    if (allowHTML) {
      container.innerHTML = text;
    } else {
      container.textContent = text;
    }
  } else {
    const textElement = document.createElement(textTag);
    if (allowHTML) {
      textElement.innerHTML = text;
    } else {
      textElement.textContent = text;
    }
    container.appendChild(textElement);
  }
  return container;
};
export {
  createTextContainer
};
//# sourceMappingURL=createTextContainer.js.map
